/* UMI&UMI — seamless single-step infinite carousel for homepage product rows.
   Unwraps Horizon's slideshow-component (removing its logic), clones the cards
   into a true loop, advances exactly one card per arrow click, wraps seamlessly,
   and keeps native touch-swipe on mobile. */
(function () {
  var SEL = '.shopify-section[id*="product_list"] .resource-list__carousel';

  function gapOf(el) {
    var cs = getComputedStyle(el);
    return parseFloat(cs.columnGap || cs.gap || '16') || 16;
  }

  function init(carousel) {
    if (carousel.dataset.umiLoop) return;
    carousel.dataset.umiLoop = '1';

    var comp = carousel.querySelector('slideshow-component');
    var track = carousel.querySelector('slideshow-slides');
    if (!track) return;

    // 1) Unwrap the slideshow-component so Horizon stops managing scroll/arrows.
    if (comp && comp.parentNode) {
      var plain = document.createElement('div');
      plain.className = comp.className;
      plain.style.cssText = comp.style.cssText;
      while (comp.firstChild) plain.appendChild(comp.firstChild);
      comp.replaceWith(plain);
    }
    // re-resolve track after unwrap
    track = carousel.querySelector('slideshow-slides');
    if (!track) return;

    var originals = Array.prototype.slice.call(
      track.querySelectorAll(':scope > slideshow-slide:not([data-umi-clone])')
    );
    if (originals.length < 3) return;

    // 2) Clone one full set before and after: [A][originals][B]
    function cloneSet(nodes) {
      return nodes.map(function (n) {
        var c = n.cloneNode(true);
        c.removeAttribute('id');
        Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
        c.setAttribute('data-umi-clone', '');
        c.style.contentVisibility = 'visible';
        return c;
      });
    }
    cloneSet(originals).forEach(function (c) { track.insertBefore(c, originals[0]); });
    cloneSet(originals).forEach(function (c) { track.appendChild(c); });
    originals.forEach(function (o) { o.style.contentVisibility = 'visible'; });

    // make sure the track is a snapping horizontal scroller
    track.style.scrollSnapType = 'x mandatory';
    track.style.overflowX = 'auto';
    track.style.scrollbarWidth = 'none';

    function setWidth() {
      var g = gapOf(track), w = 0;
      originals.forEach(function (el) { w += el.getBoundingClientRect().width + g; });
      return w;
    }
    function cardWidth() {
      return originals[0].getBoundingClientRect().width + gapOf(track);
    }
    function center() { track.scrollLeft = setWidth(); }
    requestAnimationFrame(function () { requestAnimationFrame(center); });

    // 3) Seamless wrap: once motion settles, remap scroll into the middle band [s, 2s)
    function normalize() {
      var s = setWidth();
      if (!s) return;
      var pos = track.scrollLeft;
      var mapped = s + ((((pos - s) % s) + s) % s);
      if (Math.abs(mapped - pos) > 1) {
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = mapped;
        track.style.scrollBehavior = prev;
      }
    }
    var idle;
    track.addEventListener('scroll', function () {
      clearTimeout(idle);
      idle = setTimeout(normalize, 130);
    });
    if ('onscrollend' in window) track.addEventListener('scrollend', normalize);

    // 4) Take over the arrows: one card per click, always active.
    var controls = carousel.querySelectorAll('.slideshow-control, button[aria-label*="slide" i]');
    Array.prototype.forEach.call(controls, function (btn) {
      var label = (btn.getAttribute('aria-label') || '').toLowerCase();
      var isNext = /next/.test(label) || btn.classList.contains('slideshow-control--next');
      var clone = btn.cloneNode(true);
      clone.disabled = false;
      clone.removeAttribute('disabled');
      clone.setAttribute('data-umi-arrow', isNext ? 'next' : 'prev');
      btn.replaceWith(clone);
      clone.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        track.scrollBy({ left: (isNext ? 1 : -1) * cardWidth(), behavior: 'smooth' });
      });
    });

    // 5) Vertically centre both arrows on the product IMAGE (consistent on all screens).
    function placeArrows() {
      var first = originals[0];
      if (!first) return;
      var img = first.querySelector('img') || first;
      var cRect = carousel.getBoundingClientRect();
      var iRect = img.getBoundingClientRect();
      var centerY = (iRect.top - cRect.top) + iRect.height / 2;
      if (!centerY || centerY < 10) return;
      carousel.querySelectorAll('[data-umi-arrow]').forEach(function (a) {
        a.style.top = centerY + 'px';
      });
    }
    requestAnimationFrame(function () { requestAnimationFrame(placeArrows); });
    setTimeout(placeArrows, 400);
    // re-place once product images have loaded (their height defines the centre)
    carousel.querySelectorAll('img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', placeArrows, { once: true });
    });

    var rz;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () { center(); placeArrows(); }, 200);
    });
  }

  function initAll() {
    document.querySelectorAll(SEL).forEach(init);
  }

  var style = document.createElement('style');
  style.textContent = [
    '[data-umi-loop]{position:relative;}',
    '[data-umi-loop] slideshow-slides{scrollbar-width:none;}',
    '[data-umi-loop] slideshow-slides::-webkit-scrollbar{display:none;}',
    '[data-umi-loop] slideshow-arrows{display:contents!important;}',
    // frosted white, softly rounded arrow buttons centred on the image
    '[data-umi-loop] .slideshow-control[data-umi-arrow]{',
    '  position:absolute;z-index:3;width:42px;height:42px;border-radius:9999px;',
    '  display:flex!important;align-items:center;justify-content:center;',
    '  background:rgba(255,255,255,0.66);',
    '  -webkit-backdrop-filter:blur(10px) saturate(120%);backdrop-filter:blur(10px) saturate(120%);',
    '  border:1px solid rgba(0,0,0,0.05);box-shadow:0 3px 14px rgba(0,0,0,0.14);',
    '  color:#3a3a3a;opacity:1!important;pointer-events:auto!important;cursor:pointer;',
    '  transform:translateY(-50%);',
    '  transition:transform .28s cubic-bezier(.2,.7,.3,1),box-shadow .28s ease,background .28s ease;',
    '}',
    '[data-umi-loop] .slideshow-control[data-umi-arrow] svg{width:15px;height:15px;color:#3a3a3a;stroke:#3a3a3a;fill:none;}',
    '[data-umi-loop] .slideshow-control[data-umi-arrow] svg *{stroke:#3a3a3a;}',
    '[data-umi-loop] .slideshow-control[data-umi-arrow]:hover{',
    '  transform:translateY(-50%) scale(1.09);background:rgba(255,255,255,0.9);box-shadow:0 5px 20px rgba(0,0,0,0.2);',
    '}',
    '[data-umi-loop] .slideshow-control[data-umi-arrow]:active{transform:translateY(-50%) scale(.96);}',
    "[data-umi-loop] .slideshow-control[data-umi-arrow='prev']{left:10px;right:auto;}",
    "[data-umi-loop] .slideshow-control[data-umi-arrow='next']{right:10px;left:auto;}",
    '[data-umi-clone]{content-visibility:visible!important;}',
    '@media (max-width:749px){',
    '  [data-umi-loop] .slideshow-control[data-umi-arrow]{',
    '    width:34px;height:34px;background:rgba(255,255,255,0.32);',
    '    border-color:rgba(255,255,255,0.35);box-shadow:0 1px 6px rgba(0,0,0,0.1);',
    '  }',
    '  [data-umi-loop] .slideshow-control[data-umi-arrow] svg,',
    '  [data-umi-loop] .slideshow-control[data-umi-arrow] svg *{',
    '    stroke:#2a2a2a;filter:drop-shadow(0 1px 2px rgba(255,255,255,0.6));',
    '  }',
    "  [data-umi-loop] .slideshow-control[data-umi-arrow='prev']{left:6px;}",
    "  [data-umi-loop] .slideshow-control[data-umi-arrow='next']{right:6px;}",
    '  [data-umi-loop] .slideshow-control[data-umi-arrow]:active{background:rgba(255,255,255,0.6);}',
    '}'
  ].join('');
  document.head.appendChild(style);

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
